import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ThirdPartyRepository } from '../../repositories/thirdparty.repository';
import { IpModel } from '../../models/thirdparty/ip.model';
import { LocationModel } from '../../models/thirdparty/location.model';

export class GetIpLocationUseCase implements UseCase< {ip: string}, LocationModel> {
    constructor(private thirdpaty: ThirdPartyRepository) { }
    execute(params: {ip: string}): Observable<LocationModel> {
        return this.thirdpaty.getIpLocation(params);
    }
}